module.exports = __webpack_public_path__ + "static/img/fish37.58406b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish37.png
// module id = FMtk
// module chunks = 0